import { Module } from "vuex";
import { RootState } from "../index";
import { getPlatforms } from "@/shared/api/platforms";
import { ElMessage } from "element-plus";
import { IPlatform } from "@/shared/types/platform";

export interface IState {
  list: IPlatform[];
}

const platformsModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    SET_LIST(state, list) {
      state.list = list;
    },
  },
  actions: {
    async getPlatforms({ commit }) {
      try {
        const response = await getPlatforms();
        if (response && response.code === 200 && response.data) {
          commit("SET_LIST", response.data);
          return response;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
  },
};

export default platformsModule;
